<template>
    <div class="container-fluid form-container zf-form-container">
        <form
            action=""
            @submit.prevent="saveForm"
        >
            <invoice-form :form="form" />
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Job Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <table class="table">
                        <thead>
                            <tr class="text-center">
                                <th>&nbsp;</th>
                                <th>Type</th>
                                <th>ZF</th>
                                <th>Size</th>
                                <th>L.T.D</th>
                                <th v-show="form.version === 1">
                                    BS
                                </th>
                                <th>Other</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <draggable
                            v-model="form.rows"
                            tag="tbody"
                            handle=".drag-handle"
                        >
                            <tr
                                v-for="(row, index) in form.rows"
                                :key="index"
                            >
                                <td class="drag-handle-col">
                                    <span class="drag-handle">
                                        <i class="fas fa-arrows-alt-v" />
                                    </span>
                                </td>
                                <td>
                                    <select
                                        v-model="row.type"
                                        class="form-control"
                                    >
                                        <option :value="null">
                                            Choose Type
                                        </option>
                                        <option
                                            v-for="type in feTypes"
                                            :key="type"
                                        >
                                            {{ type }}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        v-model="row.zf"
                                        class="form-control"
                                        placeholder="ZF"
                                        size="6"
                                    >
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        v-model="row.size"
                                        class="form-control"
                                        placeholder="Size"
                                        size="6"
                                    >
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        v-model="row.ltd"
                                        class="form-control"
                                        placeholder="L.T.D"
                                    >
                                </td>
                                <td
                                    class="text-center"
                                    v-show="form.version === 1"
                                >
                                    <label>
                                        <input
                                            type="checkbox"
                                            v-model="row.bs"
                                            class="form-check-input"
                                            @change="calculateBsTotal"
                                        >
                                    </label>
                                </td>
                                <td>
                                    <input
                                        v-if="form.version === 1"
                                        type="text"
                                        v-model="row.other"
                                        class="form-control"
                                        placeholder="Other"
                                    >
                                    <select
                                        v-if="form.version > 1"
                                        v-model="row.other"
                                        class="form-control"
                                    >
                                        <option>Basic Service</option>
                                        <option>Due E.S</option>
                                        <option>Empty</option>
                                        <option>Damaged</option>
                                        <option>Broken Hose/Horn</option>
                                        <option>Delivered - Refill / E.S</option>
                                        <option>Delivered - New</option>
                                    </select>
                                </td>
                                <td class="text-right">
                                    <button
                                        class="btn btn-sm btn-outline-secondary btn-icon"
                                        title="Duplicate Row"
                                        type="button"
                                        @click.prevent="duplicateRow(index)"
                                    >
                                        <i class="fa fa-copy" />
                                    </button>
                                    <button
                                        title="Delete Row"
                                        class="btn btn-sm btn-outline-danger btn-icon"
                                        type="button"
                                        @click.prevent="deleteRow(index)"
                                        :disabled="form.rows.length < 2"
                                    >
                                        <i class="fa fa-trash" />
                                    </button>
                                </td>
                            </tr>
                        </draggable>
                        <tfoot>
                            <tr v-if="form.version === 1">
                                <td>&nbsp;</td>
                                <th>BS Total:</th>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td class="text-center underline">
                                    {{ form.bs_total }}
                                </td>
                                <td colspan="2">
                                    &nbsp;
                                </td>
                            </tr>
                            <tr
                                v-for="[label, count] in rowTypes"
                                :key="label"
                            >
                                <td>&nbsp;</td>
                                <th>{{ label }}</th>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td class="text-center underline">
                                    {{ count }}
                                </td>
                                <td colspan="2">
                                    &nbsp;
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <div class="row">
                        <div class="col text-right">
                            <button
                                class="btn btn-primary"
                                type="button"
                                @click.prevent="addRow"
                            >
                                <i class="fa fa-plus" />Add Row
                            </button>
                            <button
                                class="btn btn-primary"
                                type="button"
                                :disabled="!this.form.rows || this.form.rows < 1"
                                @click.prevent="copyRow"
                            >
                                <i class="fa fa-copy" /> Copy Row
                            </button>
                            <button
                                class="btn btn-success"
                                @click.prevent="toggleScanner"
                            >
                                <i class="fa fa-qrcode" /> Scan
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isLoading || isSaving"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isLoading || isSaving"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id && form.customer_id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                v-if="$route.name === 'engineer.forms.edit' && form.job_id"
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                v-if="$route.name === 'office.forms.edit' && form.job_id"
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <scanner
            ref="scanner"
            :show="showScanner"
            @back="showScanner = false;"
            @cancel="showScanner = false;"
            @result="scannerResult"
        />
    </div>
</template>

<script>
import draggable from "vuedraggable";
import FormService from "../../services/FormService";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesErrors from "../../mixins/UsesErrors";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";
import AuthService from "../../services/AuthService";
import CustomerSearch from "../CustomerSearch.vue";
import JobService from "../../services/JobService";
import FireEx from "../../include/FireEx";
import Scanner from "../fireExtinguishers/ScannerComponent";
import InvoiceForm from "./parts/InvoiceFormComponent.vue";
import { uniq } from "lodash";

export default {
    components: {
        draggable,
        CustomerSearch,
        Scanner,
        InvoiceForm,
    },
    mixins: [UsesInfoMessage, UsesErrors, UsesFormRouteQuery],
    data() {
        return {
            form: {
                type: "zf_form",
                version: 2,
                rows: [
                    {
                        type: null,
                        other: "Basic Service",
                    },
                ],
            },
            jobs: [],
            token: null,
            feTypes: FireEx.types,
            showScanner: false,
        };
    },
    computed: {
        canDelete: function () {
            return (
                AuthService.user.admin_access || AuthService.user.office_access
            );
        },
        rowTypes: function () {
            if (this.form.version === 1) {
                return [];
            }
            const counts = {};
            this.form.rows
                .filter((r) => r.type && r.other)
                .map((r) => `${r.type}: ${r.other}`)
                .forEach((x) => {
                    counts[x] = (counts[x] || 0) + 1;
                });

            return Object.entries(counts);
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                if (this.$route.params.id) {
                    this.loadForm();
                } else {
                    this.resetForm();
                }

                this.populateFormFromRouteQuery();
                this.$forceUpdate();
            },
        },
    },
    mounted() {
        this.loadJobs();
    },
    methods: {
        addRow() {
            let newRow = {
                type: null,
                other: this.form.version > 1 ? "Basic Service" : "",
            };
            if (this.form.rows && this.form.rows.length > 0) {
                newRow.type =
                    this.form.rows[this.form.rows.length - 1].type || null;
            } else {
                this.form.rows = [];
            }
            this.form.rows.push(newRow);
            this.$forceUpdate();
        },
        copyRow() {
            if (!this.form.rows || this.form.rows.length < 1) {
                return;
            }
            this.form.rows = [
                ...this.form.rows,
                {...this.form.rows[this.form.rows.length - 1]}
            ];
        },
        deleteRow(index) {
            if (!window.confirm("Are you sure you want to delete this row?")) {
                return;
            }
            this.form.rows.splice(index, 1);
            this.$forceUpdate();
        },
        duplicateRow(index) {
            let newRow = { ...this.form.rows[index] };
            this.form.rows.push(newRow);
            this.$forceUpdate();
        },
        saveForm() {
            this.clearErrors();
            const data = { ...this.form };
            const isNew = typeof data.id === "undefined";
            const isOfficeView = this.$route.name === "office.forms.new";
            delete data["customer"];
            delete data["site"];
            data.rowTypes = [...this.rowTypes];
            this.setSaving();
            FormService.save(data)
                .then((res) => {
                    this.clearSaving();
                    this.setInfoMessage("Form saved successfully");
                    if (isNew) {
                        if (isOfficeView) {
                            this.$router.replace({
                                name: "office.forms.edit",
                                params: { id: res.data.id },
                            });
                        } else {
                            this.$router.replace({
                                name: "engineer.forms.edit",
                                params: { id: res.data.id },
                            });
                        }
                        return;
                    }
                    this.loadForm();
                })
                .catch((err) => {
                    this.clearSaving();
                    this.captureRequestErrors(err);
                    this.setErrorMessage(
                        "Form failed to save, check for errors"
                    );
                });
        },
        deleteForm() {
            if (!window.confirm("Are you sure you want to delete this form?")) {
                return;
            }
            FormService.delete(this.form)
                .then(() => {
                    this.setInfoMessage("Form successfully deleted");
                    this.$router.back();
                })
                .catch((error) => {
                    this.setErrorMessage("Could not delete this form");
                    console.error(error);
                });
        },
        loadForm() {
            FormService.get(this.$route.params.id)
                .then((res) => {
                    this.form = res.data;
                    if (!this.form.rows) {
                        this.form.rows = [
                            {
                                type: null,
                            },
                        ];
                    }
                    this.loadJobs();
                    this.calculateBsTotal();
                })
                .catch((err) => {
                    this.setErrorMessage("Could not load form");
                    this.$router.back();
                    console.error(err);
                });
        },
        resetForm() {
            this.form = {
                version: 2,
                type: "zf_form",
                rows: [
                    {
                        type: null,
                    },
                ],
            };
            this.newDocNo();
            this.calculateBsTotal();
        },
        newDocNo() {
            FormService.nextNo().then((res) => {
                this.form.doc_no = res.data;
            });
        },
        loadJobs() {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({
                "filter[customer_id]": this.form.customer_id,
            }).then(
                (res) => {
                    this.jobs = res.data.data || [];
                },
                (err) => {
                    this.setErrorMessage("Could not load customer jobs");
                    this.jobs = [];
                    console.error(err);
                }
            );
        },
        onJobLoadedFromRoute(jobData) {
            this.$forceUpdate();
            this.customerChanged(jobData.customer);
        },
        customerChanged(customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (
                    !customer.sites
                        .map((site) => site.id)
                        .includes(this.form.site_id)
                ) {
                    this.form.site_id = "";
                }
            } else {
                this.form.site_id = "";
            }
            this.loadJobs();
        },
        calculateBsTotal() {
            this.form.bs_total = this.form.rows.filter((row) => row.bs).length;
            this.$forceUpdate();
        },
        toggleScanner() {
            this.showScanner = !this.showScanner;
        },
        scannerResult(result) {
            this.showScanner = false;
            this.$refs.scanner.resetResult();
            const row = {
                type: result.type,
                zf: result.code,
                size: result.size,
                ltd: result.last_service_at
                    ? window.moment(result.last_service_at).format("DD/MM/YYYY")
                    : "",
            };
            const lastIndex = this.form.rows.length - 1;
            if (this.form.rows.length > 0 && !this.form.rows[lastIndex].zf) {
                this.form.rows.splice(lastIndex, 1);
            }
            this.form.rows.push(row);
            this.$forceUpdate();
        },
    },
};
</script>
<style lang="scss" scoped>
.table td {
    padding: 1px;
    vertical-align: middle;

    input[type="checkbox"] {
        margin: auto 0;
        position: initial;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ZFFormComponent.vue